import React from "react";
import { Alert, Button } from "@mui/material";
import { BTX_EDIT_CARRIERS, FeatureFlagBoundary } from "@platform/fe-utils";
import { Typography } from "@platform/design-system";

interface CarrierWarningAlertProps {
  onEditCarriers: () => void;
}

export function CarrierWarningAlert({
  onEditCarriers,
}: CarrierWarningAlertProps): React.JSX.Element {
  return (
    <Alert
      severity="error"
      variant="outlined"
      action={
        <FeatureFlagBoundary flag={BTX_EDIT_CARRIERS}>
          {/* TODO(ds-button): needs manual review — outlined + color="error" has no DS equivalent (danger is contained only) */}
          <Button
            color="error"
            variant="outlined"
            size="small"
            onClick={onEditCarriers}
          >
            EDIT CARRIERS
          </Button>
        </FeatureFlagBoundary>
      }
      sx={{ mb: 2 }}
    >
      <Typography variant="body-medium" color="inherit">
        Disabled carrier(s) must have a Sales Rep email added
        <br />
        before submitting RFP - edit carriers to correct this
      </Typography>
    </Alert>
  );
}
